$.fn.ajaxInvalidFeedback = function(options) {
	if (typeof options === 'object') {
		return this.each(function() {
			createInvalidFeedback($(this), options);
		});
	}
	if (options === 'destroy') {
		return this.each(function() {
			destroyInvalidFeedback($(this));
		});
	}
	return this;
};

function createInvalidFeedback($field, options) {
	const errorHtml = `<div class='invalid-feedback invalid-feedback-ajax d-block'>${options.error}</div>`;
	$field.addClass('has-invalid-feedback-ajax').after(errorHtml);
	attachFeedbackCleanupHandlers($field);
}

function destroyInvalidFeedback($field) {
	const data = $field.data('ajaxInvalidFeedback');
	if (!data) {
		return;
	}
	
	$field.off('change input', data.cleanup);
	$($field[0].form).off('submit reset', data.cleanup);
	$field.removeClass('has-invalid-feedback-ajax')
		.siblings('.invalid-feedback-ajax')
		.remove();
	$field.data('ajaxInvalidFeedback', null);
}

function attachFeedbackCleanupHandlers($field) {
	const cleanup = () => $field.ajaxInvalidFeedback('destroy');
	$field.on('change input', cleanup);
	$($field[0].form).on('submit reset', cleanup);
	$field.data('ajaxInvalidFeedback', { cleanup });
}